<template>
	<div class="Linkus">
		<div class="Linkus-top">
			<img
				:src="require('@/assets/images/linkus-top.png')"
				class="image-width"
				alt=""
			/>
		</div>

		<div class="Linkus-text">
			<img
				:src="require('@/assets/images/linkus-contact.png')"
				class="image-width"
				alt=""
			/>

			<div class="Linkus-text-self">
				<span class="text-self-left">{{ $t('联系') }}</span>

				{{ $t('我们') }}
			</div>
		</div>

		<div class="Linkus-con">
			<div
				class="Linkus-con-item"
				v-for="(item, index) in companylist"
				:key="index"
			>
				<div class="con-item-left">
					<div class="item-left-img">
						<img :src="item.img" class="image-width" alt="" />
					</div>
				</div>

				<div class="con-item-rig">
					<div class="item-rig-title">{{ getLangText(item, 'name') }}</div>

					<div class="item-rig-con">
						<div
							class="rig-con-line"
							v-for="(child, index) in item.infolist.filter(
								it => !(lang === 'en' && it.title === '邮编')
							)"
							:key="index"
						>
							<div class="con-line-title">
								{{ getLangText(child, 'title') }}:
							</div>

							<div class="con-line-text">{{ getLangText(child, 'text') }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		const salesEmail = {
			title: this.$t('销售邮箱'),

			text: 'info@cctc.cc'
		};

		const procurementEmail = {
			title: this.$t('采购邮箱'),

			text: 'gyb@cctc.cc'
		};

		const emails = [salesEmail, procurementEmail];

		return {
			companylist: [
				{
					img: require('@/assets/images/linkus-cz.png'),

					name: this.$t('潮州三环（集团）股份有限公司（总部）'),

					infolist: [
						{
							title: this.$t('地址'),

							text: this.$t('广东省潮州市凤塘三环工业城')
						},

						{
							title: '邮编',

							text: '515646'
						},

						{
							title: this.$t('电话'),

							text: '(86)-0768-6858016'
						},

						...emails
					]
				},

				{
					img: require('@/assets/images/linkus-sw.png'),

					name: this.$t('潮州三环生物新材料有限公司（子公司）'),

					infolist: [
						{
							title: this.$t('地址'),

							text: this.$t('广东省潮州市三环锡岗工业城')
						},
						{
							title: this.$t('电话'),

							text: '(86)-0768-2304035'
						},
						{
							title: this.$t('销售邮箱'),

							text: 'ceramic@cctc.cc'
						},
						{
							title: this.$t('采购邮箱'),

							text: 'gyb@cctc.cc'
						}
					]
				},

				{
					img: require('@/assets/images/linkus-nc.png'),

					name: this.$t('南充三环电子有限公司（子公司）'),

					infolist: [
						{
							title: this.$t('地址'),

							text: this.$t('四川省南充市高坪区永安路')
						},

						{
							title: this.$t('电话'),

							text: '(86)-0817-3357258'
						},

						...emails
					]
				},

				{
					img: require('@/assets/images/linkus-shenz.png'),

					name: this.$t('深圳三环科技有限公司（子公司）'),

					infolist: [
						{
							title: this.$t('地址'),

							text: this.$t(
								'广东省深圳市光明区凤凰街道甲子塘社区同仁路1号三环科技大厦'
							)
						},

						...emails
					]
				},

				{
					img: require('@/assets/images/linkus-cd.png'),

					name: this.$t('成都三环科技有限公司（子公司）'),

					infolist: [
						{
							title: this.$t('地址'),

							text: this.$t('四川省成都市金牛区蜀西路30号')
						},

						...emails

						// {

						//   title: this.$t('电话'),

						//   text: '028-60177885'

						// }
					]
				},

				{
					img: require('@/assets/images/linkus-sz.png'),

					name: this.$t('苏州三环科技有限公司（子公司）'),

					infolist: [
						{
							title: this.$t('地址'),

							text: this.$t(
								'江苏省苏州市吴中区木渎镇金枫路218号苏州三环科技有限公司'
							)
						},

						{
							title: this.$t('电话'),

							text: '18807680238'
						},

						...emails
					]
				},

				{
					img: require('@/assets/images/linkus-dy.png'),

					name: this.$t('德阳三环科技有限公司（子公司）'),

					infolist: [
						{
							title: this.$t('地址'),

							text: this.$t('四川省德阳市旌阳区燕山路505号德阳三环')
						},

						{
							title: this.$t('电话'),

							text: '(86)-0838-6130666'
						},

						...emails
					]
				},

				{
					img: require('@/assets/images/linkus-wh.png'),

					name: this.$t('武汉三寰贸易有限公司（子公司）'),

					infolist: [
						{
							title: this.$t('地址'),

							text: this.$t('湖北省武汉市江夏区高新六路10号众博工业园')
						},

						...emails
					]
				},

				{
					img: require('@/assets/images/linkus-xg.png'),

					name: this.$t('香港三环电子有限公司（子公司）'),

					infolist: [
						{
							title: this.$t('地址'),

							text: this.$t('香港荃湾横龙街32-40号兴盛工业大厦5字楼D座')
						},

						{
							title: this.$t('电话'),

							text: '(00)-852-24073751'
						},

						{
							title: '传真',

							text: '(00)-852-24073913'
						},

						...emails
					]
				},

				{
					img: require('@/assets/images/linkus-wms.png'),

					name: this.$t('德国微密斯点胶科技有限公司（子公司）'),

					infolist: [
						{
							title: this.$t('地址'),

							text: this.$t('德国 巴伐利亚州霍尔茨基兴鲁道夫·迪塞尔环')
						},

						{
							title: '传真',

							text: '+49 (0)8024 644-0'
						},

						...emails
					]
				},

				{
					img: require('@/assets/images/linkus-tg.png'),

					name: this.$t('光胜（泰国）有限公司（子公司）'),

					infolist: [
						{
							title: this.$t('地址'),

							text: this.$t('泰国春武里府是拉差县博温区6里340/2号')
						},

						{
							title: this.$t('电话'),

							text: '+66 33 004 539'
						},

						...emails
					]
				},

				{
					img: require('@/assets/images/linkus-hh.png'),

					name: this.$t('红河三环科技有限公司（子公司）'),

					infolist: [
						{
							title: this.$t('地址'),

							text: this.$t(
								'云南省红河哈尼族彝族自治州蒙自经济技术开发区科技孵化园一期一楼'
							)
						},

						...emails
					]
				}
			]
		};
	}
};
</script>

<style lang="scss">
@use './Linkus.scss';
</style>
